import { connect, useDispatch } from "react-redux";
import { IStudentAcademicDetailsProfile } from "../../../../models/student/studentAcademicProfile";
import { Chart } from "primereact/chart";
import { useEffect } from "react";
import { setStudentInfo } from "../../../../store/slices/student/studentInfoSlice";
import { setAcademicDetails } from "../../../../store/slices/student/acradamicProfileSlice";
import { getAcademicDetails } from "../../../../action/student/academicProfileActionCreator";
import { getStudentInfoDetails } from "../../../../action/student/studentInfoActionCreator";
import { getCurrentUserData } from "../../../../action/user/userProfileActionCreator";

const AcademicProfile = (props: IStudentAcademicDetailsProfile) => {
  const {
    getOverallAcademicDetails,
    academicDetails,
    getStudentInfo,
    studentInfo,
    userInfo,
  } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getOverallAcademicDetails(userInfo?.id);
      getStudentInfo(userInfo?.id);
    }
  }, [userInfo?.id]);

  useEffect(() => {
    return () => {
      dispatch(setAcademicDetails([]));
      dispatch(setStudentInfo([]));
    };
  }, []);

  const handleRedirect = () => {
    window.open("https://www.w3schools.com/", "_blank");
  };

  const data = {
    datasets: [
      {
        data: [academicDetails?.gradePointAverage, 5-academicDetails?.gradePointAverage], // Values for each segment
        backgroundColor: [
          "#0f8aad",
          "rgb(165, 164, 163)",
        ],
        hoverOffset: 8,
      },
    ],
  };
  const options = {
    cutout: '70%',
        responsive: true,
        maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "left",
        labels: {
          usePointStyle: true,
          padding: 20,
        },
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },

    elements: {
      arc: {
        borderWidth: 2,
        borderColor: "white",
        borderRadius: 10,
      },
    },
    rotation: -90,
    circumference: 180,
  };

  return (
    <>
      <div className="title">
        <h2>Academic Profile</h2>
        <button className="btn btn-small btn-primary" onClick={handleRedirect}>
          View Details / Update
        </button>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-3">
          <div className="card h-100">
            <div className="chart position-relative mb-3 d-flex justify-content-center">
              <Chart
                type="doughnut"
                data={data}
                options={options}
                className=""
                width="300"
                height="160"
              />
              <div className="gauge-desc gauge-position">
                <h2>
                  {academicDetails?.gradePointAverage}{" "}
                  <span>Grade Point Average</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 mb-3">
          <div className="card h-100">
            <ul className="grade-points">
              <li>
                <div className="img">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.7248 2.95165L4.70145 7.53665C2.44978 9.00665 2.44978 12.2966 4.70145 13.7666L11.7248 18.3516C12.9848 19.18 15.0614 19.18 16.3214 18.3516L23.3098 13.7666C25.5498 12.2966 25.5498 9.01831 23.3098 7.54831L16.3214 2.96331C15.0614 2.12331 12.9848 2.12331 11.7248 2.95165Z"
                      stroke="#948256"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.56831 15.26L6.55664 20.7317C6.55664 22.2133 7.69997 23.8 9.09997 24.2667L12.8216 25.5033C13.4633 25.7133 14.525 25.7133 15.1783 25.5033L18.9 24.2667C20.3 23.8 21.4433 22.2133 21.4433 20.7317V15.3183"
                      stroke="#948256"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9668 17.5V10.5"
                      stroke="#948256"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="desc">
                  <p>Academic Progress</p>
                  <h6>
                    {academicDetails?.academicProgress}%
                    <span className="profit">
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.99992 15.1667C11.6818 15.1667 14.6666 12.1819 14.6666 8.50004C14.6666 4.81814 11.6818 1.83337 7.99992 1.83337C4.31802 1.83337 1.33325 4.81814 1.33325 8.50004C1.33325 12.1819 4.31802 15.1667 7.99992 15.1667Z"
                          stroke="#222"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 10.8334V6.83337"
                          stroke="#222"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6 8.16663L8 6.16663L10 8.16663"
                          stroke="#222"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </h6>
                </div>
              </li>
              <li>
                <div className="img">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0001 18.3333C14.5834 18.3333 18.3334 14.5833 18.3334 9.99996C18.3334 5.41663 14.5834 1.66663 10.0001 1.66663C5.41675 1.66663 1.66675 5.41663 1.66675 9.99996C1.66675 14.5833 5.41675 18.3333 10.0001 18.3333Z"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.45825 10.0001L8.81659 12.3584L13.5416 7.64172"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="desc">
                  <p>Completed Courses</p>
                  <h6>{academicDetails?.completedCourses}</h6>
                </div>
              </li>
              <li>
                <div className="img">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.26001 11.02V15.99C4.26001 17.81 4.26001 17.81 5.98001 18.97L10.71 21.7C11.42 22.11 12.58 22.11 13.29 21.7L18.02 18.97C19.74 17.81 19.74 17.81 19.74 15.99V11.02C19.74 9.2 19.74 9.2 18.02 8.04L13.29 5.31C12.58 4.9 11.42 4.9 10.71 5.31L5.98001 8.04C4.26001 9.2 4.26001 9.2 4.26001 11.02Z"
                      stroke="#B2BFC8"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5 7.63V5C17.5 3 16.5 2 14.5 2H9.5C7.5 2 6.5 3 6.5 5V7.56"
                      stroke="#B2BFC8"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.63 10.99L13.2 11.88C13.29 12.02 13.49 12.16 13.64 12.2L14.66 12.46C15.29 12.62 15.46 13.16 15.05 13.66L14.38 14.47C14.28 14.6 14.2 14.83 14.21 14.99L14.27 16.04C14.31 16.69 13.85 17.02 13.25 16.78L12.27 16.39C12.12 16.33 11.87 16.33 11.72 16.39L10.74 16.78C10.14 17.02 9.68002 16.68 9.72002 16.04L9.78002 14.99C9.79002 14.83 9.71002 14.59 9.61002 14.47L8.94002 13.66C8.53002 13.16 8.70002 12.62 9.33002 12.46L10.35 12.2C10.51 12.16 10.71 12.01 10.79 11.88L11.36 10.99C11.72 10.45 12.28 10.45 12.63 10.99Z"
                      stroke="#B2BFC8"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="desc">
                  <p>Total Credits</p>
                  <h6>{academicDetails?.totalCourseCredits}</h6>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-6 mb-3">
          <div className="card h-100">
            <div className="title justify-content-start gap-3">
              <div className="icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.7248 2.95165L4.70145 7.53665C2.44978 9.00665 2.44978 12.2966 4.70145 13.7666L11.7248 18.3516C12.9848 19.18 15.0614 19.18 16.3214 18.3516L23.3098 13.7666C25.5498 12.2966 25.5498 9.01831 23.3098 7.54831L16.3214 2.96331C15.0614 2.12331 12.9848 2.12331 11.7248 2.95165Z"
                    stroke="#948256"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M6.56831 15.26L6.55664 20.7317C6.55664 22.2133 7.69997 23.8 9.09997 24.2667L12.8216 25.5033C13.4633 25.7133 14.525 25.7133 15.1783 25.5033L18.9 24.2667C20.3 23.8 21.4433 22.2133 21.4433 20.7317V15.3183"
                    stroke="#948256"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M24.9668 17.5V10.5"
                    stroke="#948256"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <h2>Academic Details</h2>
            </div>
            <div className="label-group-wrap">
              <div className="row">
                <div className="col-lg-12 label-group">
                  <label htmlFor="">Student Level</label>
                  <p>{studentInfo?.studentLevel}</p>
                </div>
                <div className="col-lg-12 label-group">
                  <label htmlFor="">Division</label>
                  <p>{studentInfo?.division}</p>
                </div>
                <div className="col-lg-12 label-group">
                  <label htmlFor="">Campus</label>
                  <p>{studentInfo?.campus}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 mb-3">
          <div className="card h-100">
            <div className="title justify-content-start gap-3">
              <div className="icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.3334 22.32V6.22665C29.3334 4.62665 28.0267 3.43999 26.4401 3.57332H26.3601C23.5601 3.81332 19.3067 5.23999 16.9334 6.73332L16.7067 6.87999C16.3201 7.11999 15.6801 7.11999 15.2934 6.87999L14.9601 6.67999C12.5867 5.19999 8.34675 3.78665 5.54675 3.55999C3.96008 3.42665 2.66675 4.62665 2.66675 6.21332V22.32C2.66675 23.6 3.70675 24.8 4.98675 24.96L5.37342 25.0133C8.26675 25.4 12.7334 26.8667 15.2934 28.2667L15.3467 28.2933C15.7067 28.4933 16.2801 28.4933 16.6267 28.2933C19.1867 26.88 23.6667 25.4 26.5734 25.0133L27.0134 24.96C28.2934 24.8 29.3334 23.6 29.3334 22.32Z"
                    stroke="#948256"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 7.32001V27.32"
                    stroke="#948256"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.3333 11.32H7.33325"
                    stroke="#948256"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.3333 15.32H7.33325"
                    stroke="#948256"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <h2>Program</h2>
            </div>
            <div className="label-group-wrap">
              <div className="row">
                <div className="col-lg-12 label-group">
                  <label htmlFor="">Program of Study</label>
                  <p>{studentInfo?.studentProgram?.programOfStudy}</p>
                </div>
                <div className="col-lg-6 label-group">
                  <label htmlFor="">Major</label>
                  <p>{studentInfo?.studentProgram?.major}</p>
                </div>
                <div className="col-lg-6 label-group">
                  <label htmlFor="">Minor</label>
                  <p>{studentInfo?.studentProgram?.minor}</p>
                </div>
                <div className="col-lg-12 label-group">
                  <label htmlFor="">Certificates</label>
                  <p>{studentInfo?.studentProgram?.certificates[0]}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mb-2">
        <div className="title justify-content-start gap-3">
          <div className="icon">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2134 14.4933C16.0801 14.48 15.9201 14.48 15.7734 14.4933C12.6001 14.3867 10.0801 11.7867 10.0801 8.58666C10.0801 5.31999 12.7201 2.66666 16.0001 2.66666C19.2667 2.66666 21.9201 5.31999 21.9201 8.58666C21.9067 11.7867 19.3867 14.3867 16.2134 14.4933Z"
                stroke="#948256"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.3334 17.8822C11.9468 18.176 10.6432 18.6863 9.54671 19.4133C6.32004 21.5733 6.32004 25.0933 9.54671 27.24C11.3245 28.4295 13.6539 29.0423 16 29.0783"
                stroke="#948256"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.6667 20.8807V24.3C16.6667 25.5563 16.6667 25.5563 17.8519 26.3563L21.1112 28.2407C21.603 28.5252 22.403 28.5252 22.889 28.2407L26.1482 26.3563C27.3334 25.5563 27.3334 25.5563 27.3334 24.3059V20.8807C27.3334 19.6304 27.3334 19.6304 26.1482 18.8304L22.889 16.9459C22.403 16.6615 21.603 16.6615 21.1112 16.9459L17.8519 18.8304C16.6667 19.6304 16.6667 19.6304 16.6667 20.8807Z"
                stroke="#948256"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22.0002 24.3711C22.982 24.3711 23.778 23.5752 23.778 22.5933C23.778 21.6115 22.982 20.8156 22.0002 20.8156C21.0184 20.8156 20.2224 21.6115 20.2224 22.5933C20.2224 23.5752 21.0184 24.3711 22.0002 24.3711Z"
                stroke="#948256"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h2>Student Status</h2>
        </div>
        <div className="label-group-wrap">
          <div className="row">
            <div className="col-lg-6 label-group">
              <label htmlFor="">Admissions</label>
              <p>{studentInfo?.studentStatus?.admissions}</p>
            </div>
            <div className="col-lg-6 label-group">
              <label htmlFor="">International Student</label>
              <p>{studentInfo?.studentStatus?.internationalStudent}</p>
            </div>
            <div className="col-lg-6 label-group">
              <label htmlFor="">Enrollment</label>
              <p>{studentInfo?.studentStatus?.enrollment}</p>
            </div>
            <div className="col-lg-6 label-group">
              <label htmlFor="">Holds</label>
              <p>{studentInfo?.studentStatus?.holds}</p>
            </div>
            <div className="col-lg-6 label-group">
              <label htmlFor="">Academic</label>
              <p>{studentInfo?.studentStatus?.academic}</p>
            </div>
            <div className="col-lg-6 label-group">
              <label htmlFor="">Financially Cleared</label>
              <p>{studentInfo?.studentStatus?.financiallyCleared}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getOverallAcademicDetails: (id: string) => getAcademicDetails(id),
  getStudentInfo: (id: string) => getStudentInfoDetails(id),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    academicDetails: state.academicDetail.academicDetails,
    studentInfo: state.studentInfo.studentInfo,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AcademicProfile);
